export default {
  methods: {
    upperCaseFirstLetter (str) {
      return str[0].toUpperCase() + str.slice(1)
    },

    baseName (string) {
      if (!string) {
        return
      }

      return string.split(/[\\/]/).pop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/string.js